import { HttpClient,HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {saveAs} from 'file-saver';
import {tap,map} from 'rxjs/operators';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class mensajeSesionExpiradaService {

  API_URI = environment.uri_api;

  constructor( private http:HttpClient,private router:Router ) { }


  tokenExpiradoCerrarSesion() {

  this.router.navigate(['login']);

  Swal.fire({
    html: `
      <div style="
        text-align:center; 
        font-family: Arial, sans-serif; 
        border-radius: 15px; 
        padding: 20px;
        background: linear-gradient(145deg, rgba(255,255,255,1), rgba(255,255,255,1));
      ">
        <i class="fa-solid fa-triangle-exclamation animated-icon" 
           style="font-size:50px; color:#d6c07f; margin-bottom:15px;"></i>
        <h2 style="color:#8f124d; margin:10px 0;">Sesión finalizada</h2>
        <p style="text-align:left;">Su tiempo de sesión expiró.</p>
        <hr style="border-top:1px solid #ffffff;">
        <p style="text-align:left; color:#720f3c;"><b>Importante:</b> Su acceso se cerró automáticamente. Por favor inicie sesión nuevamente para continuar.</p>
      </div>
    `,
    confirmButtonColor: '#8f124d',
    confirmButtonText: 'Ok, entiendo',
    allowOutsideClick: false,
    backdrop: `rgba(0,0,0,0.4)`
  }).then((result) => {
    if (result.isConfirmed) {
      setTimeout(() => {
        window.location.reload()
      }, 500);
    } else {
      console.log("#NA - sin respuesta");
    }
  });

  // Animación con CSS inyectado dinámicamente (solo si no existe)
  if (!document.getElementById('swal-animated-style')) {
    const style = document.createElement('style');
    style.id = 'swal-animated-style';
    style.innerHTML = `
      @keyframes bounce {
        0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
        40% { transform: translateY(-10px); }
        60% { transform: translateY(-5px); }
      }
      .animated-icon {
        animation: bounce 1s ease infinite;
      }
    `;
    document.head.appendChild(style);
  }

}


  

}
